export const textarea = {
  css: ({ dt }: any) => `
        .p-textarea {
            box-shadow: none;
            border-radius: 1rem;
            border: 1px solid rgb(226 232 240 / var(--tw-border-opacity, 1));
            padding-top: 0.75rem;
            padding-left: 1rem;
            font-size: inherit;
        }
    `,
};
